import type { OperatorChar } from "./tokenize";

export type TokenKind = "var" | "op" | "paren";

export interface Token {
  uid: string;
  kind: TokenKind;
  value: string;
}

export function makeToken(
  kind: TokenKind,
  value: string | OperatorChar,
): Token {
  return { uid: crypto.randomUUID(), kind, value };
}

export function serializeTokens(tokens: Token[]): string {
  return tokens.map((t) => t.value).join(" ");
}
